"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
var token_1 = require("../models/token");
var auth_token_1 = require("./auth-token");
var defaultvalue = {
    appId: '',
    url: '',
    storage: sessionStorage,
};
var Auth = /** @class */ (function () {
    function Auth() {
    }
    Auth.initialize = function (config) {
        if (config === void 0) { config = defaultvalue; }
        auth_token_1.default.config(config.storage);
        if (!config.appId || !config.url) {
            throw new Error('appId y url son requeridos');
        }
        return fetch(config.url, {
            method: 'POST',
            body: JSON.stringify({ resource: config.appId }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(function (response) { return response.json(); })
            .then(function (response) {
            var token = token_1.Token.fromJson(response);
            auth_token_1.default.setToken(token);
            return token;
        })
            .catch(function (error) {
            console.log('Auth -> initialize -> error', error);
        });
    };
    Auth.getAuthorization = function () {
        return auth_token_1.default.getAuthorization();
    };
    return Auth;
}());
exports.Auth = Auth;
